var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopcock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C7.58579 2 7.25 2.33579 7.25 2.75C7.25 3.16421 7.58579 3.5 8 3.5H9.75V5.33015C9.61443 5.385 9.4835 5.45533 9.35983 5.54114L7 7.17859L4 7.17871C2.89543 7.17871 2 8.07414 2 9.17871V10.3216C2 11.4261 2.89543 12.3216 4 12.3216H7L9.35984 13.9589C10.0455 14.4346 10.9545 14.4346 11.6402 13.9589L14 12.3214L15.75 12.3216C16.4404 12.3216 17 12.8972 17 13.6073V16C16.5858 16 16.25 16.3358 16.25 16.75C16.25 17.1642 16.5858 17.5 17 17.5H22C22.4142 17.5 22.75 17.1642 22.75 16.75C22.75 16.3358 22.4142 16 22 16V12.3216C22 9.48125 19.7614 7.17871 17 7.17871H14L11.6402 5.54114C11.5165 5.45533 11.3856 5.385 11.25 5.33015V3.5H13C13.4142 3.5 13.75 3.16421 13.75 2.75C13.75 2.33579 13.4142 2 13 2H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22C20.3284 22 21 21.2538 21 20.3333C21 19.8285 20.5488 19.1755 20.1413 18.6888C19.8017 18.2831 19.1983 18.2831 18.8587 18.6888C18.4512 19.1755 18 19.8285 18 20.3333C18 21.2538 18.6716 22 19.5 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopcock);
export default __webpack_public_path__ + "static/media/stopcock.4770f1bcf6f6e95ad54a092ce2620bb2.svg";
export { ForwardRef as ReactComponent };